export const siteChromeNavigationStoreKey = "Asos.SiteChrome.Navigation";
export const expirationInMs = 5 * 60 * 1000;
